import { DatePipe, NgClass } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem, PrimeNGConfig, SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { Menu, MenuModule } from 'primeng/menu';
import { SidebarModule } from 'primeng/sidebar';
import { take } from 'rxjs';
import { HeaderFooterService } from '../../../core/services/header-footer.service';
import { CuadroMedicoIframeService } from '../../../pages/private/cuadro-medico-iframe/services/cuadro-medico-iframe.service'; //iframe directorio medico
import { PolizasCuadro } from '../../../pages/private/cuadro-medico/models/busqueda';
import { CuadroMedicoService } from '../../../pages/private/cuadro-medico/services/cuadro-medico.service';
import { Chipcard } from '../../../pages/private/mi-cigna/models/mi-cigna';
import { SolicitudCertificadoService } from '../../../pages/private/solicitud-certificado/services/solicitud-certificado.service';
import { SolicitudCitaService } from '../../../pages/private/solicitud-cita/services/solicitud-cita.service';
import { SolicitudReembolsoHospService } from '../../../pages/private/solicitud-reembolso-hosp/services/solicitud-reembolso-hosp.service';
import { CignaIconComponent } from '../../../shared/components/cigna-icon/cigna-icon.component';
import { StorageKeys } from '../../../shared/enums/storage-keys.enum';
import { UrlKeys } from '../../../shared/enums/urls.enum';
import { ModalContactoComponent } from '../../../shared/modals/modal-contacto/modal-contacto.component';
import { InsuredData } from '../../../shared/models/user-data';
import { ApiPrivateService } from '../../../shared/services/api-private.service';
import { ApiService } from '../../../shared/services/api.service';
import { AuthService } from '../../../shared/services/auth.service';
import { CacheDataService } from '../../../shared/services/cache-data.service';
import { ConsoleService } from '../../../shared/services/console.service';
import { EnvironmentService } from '../../../shared/services/environment.service';
import { ModalService } from '../../../shared/services/modal.service';
import { StorageDataService } from '../../../shared/services/storage-data.service';
import { StorageService } from '../../../shared/services/storage.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { InsuredDropdownComponent } from '../insured-dropdown/insured-dropdown.component';
import { MarqueeComponent } from '../marquee/marquee.component';
import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    SidebarModule,
    SharedModule,
    CignaIconComponent,
    InsuredDropdownComponent,
    DatePipe,
    DropdownModule,
    FormsModule,
    ButtonModule,
    NgClass,
    MenuModule,
    TranslateModule,
    NotificationsComponent,
    MarqueeComponent,
  ],
})
export class HeaderComponent implements OnInit {
  private _apiService = inject(ApiService);
  private _apiPrivateService = inject(ApiPrivateService);
  private _authService = inject(AuthService);
  private _cacheDataService = inject(CacheDataService);
  private _consoleService = inject(ConsoleService);
  private _cuadroMedicoService = inject(CuadroMedicoService);
  private _cuadroMedicoIframeService = inject(CuadroMedicoIframeService); //iframe directorio medico
  private _headerFooterService = inject(HeaderFooterService);
  private _modalService = inject(ModalService);
  private _primeNGConfig = inject(PrimeNGConfig);
  private _router = inject(Router);
  private _solicitudCertificadoService = inject(SolicitudCertificadoService);
  private _solicitudCitaService = inject(SolicitudCitaService);
  private _solicitudReembolsoHospService = inject(SolicitudReembolsoHospService);
  private _storageDataService = inject(StorageDataService);
  private _storageService = inject(StorageService);
  private _translateService = inject(TranslateService);
  private _utilsService = inject(UtilsService);
  private _environmentService = inject(EnvironmentService);

  @ViewChild('dropdown') dropdown!: Dropdown;
  @ViewChild('menu1') menu1!: Menu;
  isApp: boolean = this._utilsService.isApp();
  languages: any[] = [];
  currentLanguage: any;
  logged!: boolean;
  menuItems: MenuItem[] = [];
  itemsAuthorized: any[] = [];
  isAuthorized: boolean = true;
  iniciales: string = '';
  inicialesfam1: string = '';
  inicialesfam2: string = '';
  inicialesfam3: string = '';
  count: number = 0;
  showMenu: boolean = false;
  menu: number = -1;
  numberDrCigna: number = 0;
  authorizedDerechoReembolso: boolean = false;
  authorizedDerechoAutorizaciones: boolean = false;
  tieneChipcard: boolean = false;
  polizaSalud: boolean = false;
  primeraVez: boolean = true;
  logData!: InsuredData;
  activeSelected: string = '';
  activeSelectedBackup: string = '';
  menuOpen: string = '';
  logout: boolean = false;
  cuadroMedico: boolean = false;
  numItemsGestiones: number = 0;
  polizas: PolizasCuadro[] = [];
  isCignaPolicy: boolean = false;
  isAppointmentsAvailable: boolean = false;

  mainMessage: string = '';

  chipcards: Chipcard[] = [
    {
      cardNumber: '',
      cardNumberExt: '',
      cardVersion: '',
      personNumber: '',
      policy: {
        code: '',
        expired: false,
        name: '',
        planCode: '',
        planDesc: '',
        riders: '',
        health: false,
      },
      startDate: '',
      subscriberNumber: '',
    },
  ];

  menuOpcion: { [key: string]: boolean } = {};

  ngOnInit(): void {
    this._environmentService
      .getEnvironment()
      .pipe(take(1))
      .subscribe((environment: any) => {
        this.isAppointmentsAvailable = environment.appointmentsAvailable === 'true';
        this._authService.logged$.subscribe((val: boolean) => {
          this.logged = val;
          this.getHomeData();
          this.getItems();
        });
        this.getHomeData();
        this.getItems();
        this.getMenuActiveSelected();
        this.getMessage();
        this._router.events.subscribe(() => {
          if (this._router.url.indexOf(UrlKeys.LOGOUT) !== -1) {
            this.logout = true;
          } else {
            this.logout = false;
          }
        });
        this._router.events.subscribe(() => {
          if (this._router.url.indexOf(UrlKeys.CUADRO_MEDICO) !== -1) {
            this.cuadroMedico = true;
          } else {
            this.cuadroMedico = false;
          }
        });
      });
  }

  getMenuActiveSelected(): void {
    this._headerFooterService.menuOptionSelected$.subscribe((val: string) => {
      this.activeSelected = val;
      this.activeSelectedBackup = val;
    });
  }

  noCerrar(event: Event): void {
    event.stopPropagation();
  }

  getHomeData(): void {
    this.logData = this._storageService.sessionStorageGetItem(StorageKeys.LOGIN_DATA);
    this.iniciales = this._utilsService.iniciales(this.logData.fullName);
    this.getLanguages();
    this.getChipcard();
    for (let i = 0; i <= this.logData.authorized?.length; i++) {
      if (this.logData.authorized[i]?.showReimbursement) {
        this.authorizedDerechoReembolso = true;
      }
      if (this.logData.authorized[i]?.showAuthorization) {
        this.authorizedDerechoAutorizaciones = true;
      }
    }
  }

  getChipcard(): void {
    if (!this._utilsService.isEmpty(this.logData.insuranceNumber) && !!this.primeraVez) {
      this._cacheDataService
        .getChipcard(this.logData.insuranceNumber)
        .pipe(take(1))
        .subscribe(chipcards => {
          if (!this._utilsService.isEmpty(chipcards)) {
            for (let i = 0; i < chipcards.length; i++) {
              if (chipcards[i].cardNumber !== chipcards[i].cardNumberExt) {
                this.tieneChipcard = true;
              }
              if (chipcards[i].policy?.health) {
                this.polizaSalud = true;
              }
              if (['100001'].includes(chipcards[i].policy?.code)) {
                this.isCignaPolicy = true;
              }
            }
          }
          if (!!this.isAppointmentsAvailable || !!this.isCignaPolicy) {
            this.isAppointmentsAvailable = true;
          } else {
            this.isAppointmentsAvailable = false;
          }
          this.getItems();
        });
      this.primeraVez = false;
    }
  }

  ordenarNombre(fullName: string): string {
    return this._utilsService.nombreMinusculas(fullName);
  }

  authorizedClicked(): void {
    this.showMenu = false;
  }

  getDrCigna(): boolean {
    let esVisible: boolean = false;
    let numberDrCigna: number = 0;
    if (this.logData.showPhemium) {
      esVisible = true;
      numberDrCigna++;
    } else {
      if (Array.isArray(this.logData.authorized)) {
        for (const authorized of this.logData.authorized) {
          if (authorized.isAuthorized) {
            if (authorized.showPhemium) {
              esVisible = true;
              numberDrCigna++;
            }
          }
        }
      }
    }
    this.numberDrCigna = numberDrCigna;
    return esVisible;
  }

  private getItems(): void {
    this.menuItems = [
      {
        label: 'headerLog.telemedicina',
        visible: !this.logData.isAdmin && !this.logData.isPremember,
        items: [
          {
            label: 'headerLog.opcionMedicina.videoconsulta',
            icon: 'videoconsulta',
            visible: !!this.polizaSalud && !!this.isAppointmentsAvailable,
            command: (): void => {
              this._solicitudCitaService.inicioNuevaCita('video');
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
          {
            label: 'headerLog.opcionMedicina.telederma',
            icon: 'telederma',
            visible: !!this.polizaSalud && !!this.isAppointmentsAvailable,
            command: (): void => {
              this._solicitudCitaService.inicioNuevaCita('telederma');
              setTimeout(() => this.menu1.hide(), 200);
            },
          },

          {
            label: 'headerLog.opcionMedicina.dr',
            subItem: '',
            icon: 'online-doctor',
            visible: this.getDrCigna() === true,
            command: (): void => {
              this._solicitudReembolsoHospService.goDrCigna(this.numberDrCigna);
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
          {
            label: 'headerLog.opcionMedicina.wellbeing',
            subItem: 'headerLog.opcionMedicina.sub_wellbeing',
            icon: 'phone-health',
            visible: !this.isAppointmentsAvailable,
            command: (): void => {
              this._router.navigate([
                `/${UrlKeys.TELEMEDICINA}/${UrlKeys.TELEMEDICINA_WELLBEING}`,
              ]);
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
          {
            label: 'headerLog.opcionMedicina.telefonica',
            icon: 'tellamamos',
            visible: !!this.polizaSalud && !!this.isAppointmentsAvailable,
            command: (): void => {
              this._solicitudCitaService.inicioNuevaCita('telef');
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
          {
            label: 'headerLog.opcionMedicina.telefono',
            icon: 'phone',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.TELEMEDICINA}/${UrlKeys.TELEMEDICINA_SOPORTE}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
        ],
      },
      {
        label: 'headerLog.gestiones',
        visible: !this.logData.isAdmin,
        items: [
          {
            label: 'headerLog.opcionGest.cuadro',
            icon: 'medical',
            command: (): void => {
              this._storageService.sessionStorageSetItem(
                StorageKeys.SELECTED_OPTION_DM,
                'CuadroMedico'
              );
              if (!this.isAppointmentsAvailable) {
                this._cuadroMedicoIframeService.newMedical(false); //iframe directorio medico
              } else {
                this._cuadroMedicoService.newCuadroMedico();
              }
              setTimeout(() => this.menu1.hide(), 200);
              //this._router.navigate([`/${UrlKeys.CUADRO_MEDICO}`]);
            },
          },
          {
            label: 'headerLog.opcionGest.certificado',
            icon: 'doc-info',
            visible: !this.logData.isPremember && !!this.tieneChipcard,
            command: (): void => {
              this._solicitudCertificadoService.newSolicCertificado();
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
          {
            label: 'headerLog.opcionGest.reembolso',
            icon: 'money',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.REEMBOLSOS}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
            visible:
              !this.logData.isPremember &&
              (!!this.logData.showReimbursement || !!this.authorizedDerechoReembolso),
          },
          {
            label: 'headerLog.opcionGest.reemHospital',
            icon: 'premium',
            command: (): void => {
              this._solicitudReembolsoHospService.newReinbursementHosp();
              setTimeout(() => this.menu1.hide(), 200);
            },
            visible: !this.logData.isPremember,
          },
          {
            label: 'headerLog.opcionGest.auth',
            icon: 'doc-ok',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.AUTORIZACIONES}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
            visible:
              !this.logData.isPremember &&
              (!!this.logData.showAuthorization || !!this.authorizedDerechoAutorizaciones),
          },
          {
            label: 'headerLog.opcionGest.citas',
            icon: 'date',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.CITAS}`]);
            },
            visible: !this.logData.isPremember && !!this.isAppointmentsAvailable,
          },
        ],
      },
      {
        label: 'headerLog.soporte',
        visible: !this.logData.isAdmin,
        items: [
          {
            label: 'headerLog.opcionSoporte.contact',
            icon: 'support',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.SOPORTE}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
          {
            label: 'headerLog.opcionSoporte.preguntas',
            icon: 'comunication',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.SOPORTE}/${UrlKeys.SOPORTE_PREGUNTAS}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
        ],
      },
      {
        label: 'headerLog.mas',
        visible: !this.logData.isAdmin,
        items: [
          {
            label: 'headerLog.opcionMas.masSalud',
            icon: 'heart-add',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.MAS_SALUD}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
          },
        ],
      },
      {
        label: '',
        items: [
          {
            label: 'headerLog.opcionPerfil.miCigna',
            icon: 'leaves-solid',
            command: (): void => {
              this._storageDataService.cleanAuthorized();
              this._router.navigate([`/${UrlKeys.MI_CIGNA}`]);
              setTimeout(() => this.menu1.hide(), 200);
            },
            visible: !this.logData.isAdmin,
          },
          {
            label: 'headerLog.opcionPerfil.ajustes',
            icon: 'config',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.SETTINGS}`]);
            },
            visible: !!this.isApp,
          },
          {
            label: 'headerLog.opcionPerfil.pass',
            icon: 'key',
            command: (): void => {
              this._router.navigate([`/${UrlKeys.CHANGE_PASS}`]);
            },
            visible: !this.logData.isAdmin,
          },
          { label: 'headerLog.opcionPerfil.idioma', icon: 'world' },
          {
            label: 'headerLog.opcionPerfil.exit',
            icon: 'log-out',
            styleClass: 'close-menu',
            command: (): void => {
              this._authService.logOut();
            },
          },
        ],
      },
    ];

    //número de items en menu Gestiones
    this.numItemsGestiones = 0;
    //premember
    if (this.logData.isPremember) {
      this.numItemsGestiones += 1;
    } else {
      //cuadro medico+reembhosp+citas+telederma
      this.numItemsGestiones += 4;
      //certificados si tiene chipcard
      if (this.tieneChipcard) {
        this.numItemsGestiones += 1;
      }
      //reembolsos
      if (this.logData.showReimbursement || this.authorizedDerechoReembolso) {
        this.numItemsGestiones += 1;
      }
      //autorizaciones
      if (this.logData.showAuthorization || this.authorizedDerechoAutorizaciones) {
        this.numItemsGestiones += 1;
      }
    }
  }

  dropdownDes(event: Event, item: string): void {
    if (item === 'headerLog.opcionPerfil.idioma') {
      event.stopPropagation();
      this.toggleDropdown();
    }
  }

  isDropdownOpen = false;
  toggleDropdown(): void {
    if (this.isDropdownOpen) {
      this.dropdown.hide();
    } else {
      this.dropdown.show();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  openMenu(opcion: string): void {
    this.activeSelected = '';
    this.menuOpen = opcion;
    this.menuOpcion[opcion] = true;
  }

  closeMenu(opcion: string): void {
    this.menuOpcion[opcion] = false;
    if (this.menuOpen === opcion) {
      this.activeSelected = this.activeSelectedBackup;
    }
  }

  goToMenuOption(event: any, item: MenuItem): void {
    if (item.command) {
      this.showMenu = false;
      item.command(event);
    }
  }

  private getLanguages(): void {
    this._translateService
      .get('header')
      .pipe(take(1))
      .subscribe(() => {
        this.languages = [
          { name: this._translateService.instant('header.espanol'), code: 'es' },
          { name: this._translateService.instant('header.english'), code: 'en' },
        ];
        this.currentLanguage = this.languages.find(
          item => item.code === this._translateService.currentLang
        );
      });
  }

  languageChange(event: any): void {
    this._translateService.use(event.value.code);
    this._translateService
      .get('primeng')
      .subscribe(res => this._primeNGConfig.setTranslation(res));
    this._storageService.localStorageSetItem(StorageKeys.LANGUAGE, event.value.code);
    document.documentElement.lang = event.value.code;
    this._consoleService.log('[LanguageChange]', event.value.code);
    if (this._authService.isLogged()) {
      this._apiPrivateService.changePreferedLanguage(event.value.code).pipe(take(1)).subscribe();
    }
    this.getMessage();
  }

  contacto(): void {
    this._modalService.showModal(ModalContactoComponent, {}, '260px');
  }

  contactoMovil(): void {
    this._modalService.showModal(ModalContactoComponent, {}, '92%');
  }

  logOut(): void {
    this._authService.logOut();
  }

  goHome(): void {
    this._router.navigate([`/${UrlKeys.HOME}`]);
    this.showMenu = false;
  }

  setMenu(option: number): void {
    this.menu = option;
  }

  resetMenu(): void {
    this.menu = -1;
  }

  getMessage(): void {
    this._apiService
      .messageManagement('MAIN_BANNER')
      .pipe(take(1))
      .subscribe(res => {
        if (res.html) {
          this.mainMessage = res.html;
        }
      });
  }
}
